module.exports = __webpack_public_path__ + "img/WeChatPay.bd5cd984.png";